import $api from "../http";

export default class AuthService {
    static async login(email, password) {
        return $api.post("/user/login", {email, password})
    }

    static async register(email, name, password) {
        return $api.post("/user/register", {email, name, password})
    }

    static async logout() {
        return $api.post("/user/logout")
    }

    static async delete(email) {
        return $api.delete("/user/delete", {data: {email}})
    }

    static async forgotPassword(email) {
        return $api.post("/user/forgot", {email})
    }

    static async checkHash(hash) {
        return $api.get(`/user/check-reset/${hash}`, {data: {hash}})
    }

    static async resetPassword(password, email) {
        return $api.post("/user/reset", {password, email})
    }
}